<template>
  <div>
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md12 lg2 hidden-md-and-down v-if="storage">
        <v-navigation-drawer
          class="fixedSidebar"
          v-model="sideNav"
          clipped
          width="100%"
          height="100vh"
          permanent
          color="#202020"
        >
          <!-- <v-layout wrap justify-center>
            <template v-for="item in stylCategories">
              <v-flex
                xs12
                :key="item._id"
                text-center
                py-2
                text-uppercase
                align-self-center
              >
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <span
                      :style="
                        $route.query.styl == item._id
                          ? {
                              'font-family': 'poppinsbold',
                            }
                          : {
                              'font-family': 'poppinsthin',
                            }
                      "
                      style="
                        font-size: 15px;
                        color: #ffffff;
                        letter-spacing: 3px;
                        cursor: pointer;
                      "
                      @click="changeRoute(item)"
                    >
                      {{ item.name }}
                    </span>
                  </v-flex>
                  <v-flex xs12 pt-2 px-4>
                    <div style="border-bottom: 1px solid #ffffff25"></div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </v-layout> -->
        </v-navigation-drawer>
      </v-flex>
      <v-flex  xs12 sm12 md12 :lg10="storage" :lg12="!storage" pt-8 pt-md-0  px-4>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage"],
    // metaInfo() {
    // const a = "test";
    // return {
    //   title: "Home",
    //   meta: [
    //     ...(a === "test" && [
    //       {
    //         vmid: "description",
    //         name: "description",
    //         content:
    //           "hello world, this is an example of adding a description with vue-meta"
    //       }
    //     ])
    //   ]
    // };
    // },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      sideNav: true,
    };
  },
  beforeMount() {
    // this.$store.dispatch("getStylCategory");
  },
  computed: {
    // stylCategories() {
    //   return this.$store.state.stylCategories;
    // },
  },
  methods: {
  
    changeRoute(item) {
      this.$router.push({
        path: "/Products",
        query: {
          styl: this.$route.query.styl != item._id ? item._id : null,
          category: this.$route.query.category,
          subcategory: this.$route.query.subcategory,
          searchKey: this.$route.query.searchKey,
          type: this.$route.query.type,
        },
      });
    },
  },
};
</script>